// extracted by mini-css-extract-plugin
export default {"container":"EYX6v_container"};